<template>
  <div>
    <div v-if="!businessInfo?.businessPersonalInformation">
      <SystemAlert />
    </div>
    <div>
      <Tab />
    </div>
  </div>
</template>
  
<script setup>
import { useStore } from 'vuex';
import { computed, onMounted, onUnmounted } from 'vue';
import appConfig from '@/app.config';
import Tab from '@/components/tabs/Tab.vue';
import * as COMMONS from '@/store/_commons';
import SystemAlert from '@/components/SystemAlert';
import { useHead } from '@unhead/vue'

useHead({
  title: `BusinessProfile | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'You can view your Business Information, Credentials, Registrations, Adjudications, Make Reservations'
    }
  ]
});

const store = useStore();

// Computed props
const businessInfo = computed(() => store.getters[COMMONS.BUSINESS_PROFILE_INFO]);

// Functions 
const getBusinessProfile = () => {
  store.dispatch(COMMONS.BUSINESS_PROFILE_GET_PROFILE);
};

getBusinessProfile();

// Ensure store flag is set correctly for business users
store.commit('guestLogin/setState', { 
  property: 'isBusinessUser', 
  value: true 
});

store.state.guestLogin.loginUserDetails = null;

const handlePopstate = () => {
  history.go(1);
};

onMounted(() => {
  window.history.replaceState(history.state, "", window.location.href);

  window.addEventListener('popstate', handlePopstate);

  window.addEventListener("message", (event) => {
    if (event.origin !== "https://ridmvwebtest-dev.ri.gov") {
      return;
    }

    // Process the message data
    const message = event.data;
    console.log('Received message:', message);
  });
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopstate);
});
</script>
